export default __webpack_public_path__ + "static/media/partner (7).f4c73a21.png";